module.exports = __webpack_public_path__ + "static/about-c4f6fc5938723d2419dc046446e658c9.jpg";